import properties from '../properties';

const pageTitleMixin = {
  methods: {
    updatePageTitle () {
      if (typeof this.pageTitle !== 'undefined' && this.pageTitle) {
        document.title = this.pageTitle + ' - ' + properties.appTitle;
      }
    }
  },

  watch: {
    pageTitle: {
      immediate: true,
      handler () {
        this.updatePageTitle();
      }
    }
  }
};

export default pageTitleMixin
